import React, { useEffect } from "react";
import imageHero from "../../assets/myimages3.png";
import imageHero1 from "../../assets/myImage1.png";
import imageHero3 from "../../assets/finalMe.png";
import FindMeBestSkillOn from "../FindMeBestSkillOn/FindMeBestSkillOn";
import Typed from "react-typed";
import AOS from "aos";
import "aos/dist/aos.css";
import gifImage from "../../assets/gif/74694-confetti-unscreen.gif";
import gifImage2 from "../../assets/gif/spener animation.gif";

const Hero = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div id="home" className="  hero py-12 md:px-0 px-6">
      <div className=" MyContainer relative  md:flex  md:flex-row flex-col-reverse  gap-4 w-full md:justify-around md:items-center   pt-20">
        <div data-aos="zoom-in" className="md:px-0   md:w-[50%] md:mb-0 mb-10">
          <img className="absolute opacity-50" src={gifImage} alt="" />

          <span className="   font-light  inline-block  rounded-lg text-light_white  text-md ">
            WELCOME TO MY WORLD
          </span>

          <span className="text-xl font-medium  text-light_white block">
            Hi There
          </span>
          <h2 className=" sm:text-5xl text-4xl lg:text-6xl text-light_white mb-3 font-bold ">
            I’m <span className="text-own-secondary">Sohag Hossain</span>
          </h2>
          <h4 className=" text-3xl text-light_white  lg:text-4xl w-[100%] font-medium  mb-4 flex">
            <span className="text-own-secondary font-bold mr-3">A</span>
            <Typed
              strings={[
                "Full-Stack Developer",
                "Front-End developer",
                "MERN Stack Developer",
                "React Developer",
                "Professional Coder",
              ]}
              loop
              typeSpeed={25}
              backSpeed={20}
              // backDelay={10}
              // startDelay={100}
              smartBackspace={true}
              cursorChar=" ⫯"
              showCursor={true}
            />
            <br />
          </h4>
          <p className="text-sm lg:text-lg  font-light text-light_white text-justify ">
            Working with{" "}
            <span className="text-own-secondary font-medium"> React</span>,{" "}
            <span className="text-own-secondary font-medium">NextJs</span>,{" "}
            <span className="text-own-secondary font-medium"> Redux</span>,
            <span className="text-own-secondary font-medium"> NodeJS</span>,{" "}
            <span className="text-own-secondary font-medium"> ExpressJs</span>,{" "}
            <span className="text-own-secondary font-medium">MongoDB</span>. I'm
            will be responsible for building and maintaining MERN STACK web
            applications and will play a key role in the development of our
            projects . MERN Stack Developer
          </p>
          <FindMeBestSkillOn />
        </div>
        <div className="flex items-center justify-center">
          <div
            data-aos="flip-left"
            className=" w-[70%] md:w-full md:h-[100%] overflow-hidden  bg-own-primary relative after:absolute after:w-full after:h-[400px] after:bg-own-primary after:bg-opacity-[.1] after:left-0 after:top-0 bg-opacity-25 rounded-lg border-[1px]  border-own-border-color border-opacity-10 hero_animation "
          >
            <img className="md:w-[290px] mx-auto " src={imageHero3} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
